var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#E20074"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3711 6.75908L8.33137 13.8697C8.29051 13.911 8.24199 13.9438 8.18857 13.9661C8.13516 13.9885 8.07791 14 8.02009 14C7.96227 14 7.90501 13.9885 7.8516 13.9661C7.79819 13.9438 7.74966 13.911 7.7088 13.8697L4.62894 10.7588C4.54638 10.6754 4.5 10.5623 4.5 10.4444C4.5 10.3264 4.54638 10.2133 4.62894 10.1299C4.7115 10.0465 4.82347 9.9997 4.94023 9.9997C5.05698 9.9997 5.16895 10.0465 5.25151 10.1299L8.02009 12.927L14.7485 6.13024C14.831 6.04685 14.943 6 15.0598 6C15.1765 6 15.2885 6.04685 15.3711 6.13024C15.4536 6.21363 15.5 6.32673 15.5 6.44466C15.5 6.56259 15.4536 6.67569 15.3711 6.75908Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.15c08178c2b4f53c1858fb74f8a963bf.svg";
export { ForwardRef as ReactComponent };